import React from "react";
import Select from 'react-select';

export default class extends React.Component {


    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.valid = this.valid.bind(this);

        const {field, formData, multiselect} = this.props;
        formData[field.name] = formData[field.name] || (multiselect ? field.parameters.default : field.default);
        
        this.state = {
            valid: true
        }
    }

    handleChange(selectedOption) {
        const {field, config, formData, multiselect} = this.props;

        let value;

        if (multiselect) {
            value = selectedOption ? selectedOption.map((item) => item.value).join("|") : selectedOption;
        } else {
            value = selectedOption ? selectedOption.value : selectedOption;
        }

        formData[field.name] = value;

        this.valid();

        try {
            this.props.onChange()
        } catch (e) {

        }
    }

    valid() {
        const {field, config, formData} = this.props;

        if (!field.required) {
            return true
        }

        this.setState({
            valid: !!formData[field.name]
        })


    }

    getOpinions(field, multiselect) {


        let opinions = field.options;

        if (!opinions){
            opinions = field.parameters.opinions.split("|")
        }

        return opinions.map((item) => {
            return {value: item, label: item}
        });

    }

    getCurrentOpinion(field, multiselect, formData) {

        const currentValue = formData[field.name];


        if (!currentValue) {
            return null
        }

        if (multiselect) {
            return currentValue.split("|").map((item) => {
                return {value: item, label: item}
            })
        }

        return {value: currentValue, label: currentValue}
    }

    render() {
        const {field, config, formData, multiselect,id} = this.props;
        const {valid} = this.state;

        let title = field.title;
        if(title.substr(-1) == "*"){
            title = title.slice(0, -1)
        }
        if (field.required) {
            title = <span>{title} <span className='pubhub-smartsheet-form-required'>*</span></span>
        }

        const options = this.getOpinions(field, multiselect);
        const currentValue = this.getCurrentOpinion(field, multiselect, formData);

        return (
            <div
                className={"row pubhub-smartsheet-form-element pubhub-smartsheet-select " + (valid ? "" : "has-danger")}
                key={field.id}>
                <div className="pubhub-smartsheet-label">
                    <label htmlFor={field.id} className="col-form-label">{title}</label>
                </div>
                <div className="pubhub-smartsheet-element" key={id}>
                    <Select
                        defaultValue={currentValue}
                        onChange={this.handleChange}
                        options={options}
                        isClearable={true}
                        isMulti={multiselect}
                    />
                    <small id={field.id + 'passwordHelpBlock'} className="form-text text-muted">
                        {field.helpText}
                    </small>
                </div>
            </div>

        )
    }
}
